import React from 'react';
import './index.css';
import img from '../../img/web_dev.png'
import { SiDjango, SiReact, SiRuby } from 'react-icons/si';
import { GrNode } from 'react-icons/gr';
import { FaLaravel, FaAngular } from 'react-icons/fa';

function WebDev(){
    return (
        <>
            <div className="section" id="webdevhead">
                <div className="container">
                    <div className="box">
                        <h1>Web Development Service</h1>
                        <p>Our website developers provide expert web application development and web design services to our clients. Appnovation offers a variety of website design and development services, from creating mobile web development solutions, to building custom e-commerce using the latest and proven web technologies. </p>
                        <p>With up to 85% of consumers visiting company’s or service provider’s website before making a purchase, more and more consumers make decisions based on their online experience: the appearance, usability and accessibility of your website is more important than ever, especially in an increasingly competitive market.</p>
                        {/* <button className="btn btn-primary">Contact us now</button> */}
                    </div>
                    <img src={img} className="box image" alt='web development'/>
                </div>
            </div>

            <div className="section stripe">
                <div className="box">
                    <h3>We are updated with the latest web development technologies and our developers are well experienced to deliver the fastest and valuable services.</h3>
                </div>
                <div className="box">
                    <div className="box image"></div>
                    <dib className="box">
                        <p>Frameworks are built to support the construction of internet applications based on a single programming language</p>
                    </dib>
                </div>
            </div>

            <div className="section tech">
                <div className="grid">
                    <div className="box">
                        <div className="icon">
                            <SiDjango />
                        </div>
                        <div className="content">
                            <h3>Django</h3>
                            <p>Django is a high-level Python web framework that encourages rapid development and clean, pragmatic design</p>
                        </div>
                    </div>
                    <div className="box">
                        <div className="icon">
                            <SiReact />
                        </div>
                        <div className="content">
                            <h3>React</h3>
                            <p>React is a free and open-source front-end JavaScript library for building user interfaces or UI components</p>
                        </div>
                    </div>
                    <div className="box">
                        <div className="icon">
                            <GrNode />
                        </div>
                        <div className="content">
                            <h3>Node</h3>
                            <p>Node.js is an open-source, cross-platform, back-end JavaScript runtime environment that executes JavaScript code outside a web browser</p>
                        </div>
                    </div>
                    <div className="box">
                        <div className="icon">
                            <FaLaravel />
                        </div>
                        <div className="content">
                            <h3>Laravel</h3>
                            <p>Laravel is a free, open-source PHP web framework, created by Taylor Otwell and intended for the development of web applications</p>
                        </div>
                    </div>
                    <div className="box">
                        <div className="icon">
                            <SiRuby />
                        </div>
                        <div className="content">
                            <h3>Ruby on Rails</h3>
                            <p>Ruby on Rails, or Rails, is a server-side web application framework written in Ruby under the MIT License</p>
                        </div>
                    </div>
                    <div className="box">
                        <div className="icon">
                            <FaAngular />
                        </div>
                        <div className="content">
                            <h3>Angular</h3>
                            <p>Angular is a TypeScript-based free and open-source web application framework led by the Angular Team at Google</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WebDev;